module.exports = __webpack_public_path__ + "img/greyCross-1.98f22907.svg";